export default __webpack_public_path__ + "static/media/interior-1.d4502c0f.jpg";